import * as constActions from './searchConstActions';
import initialState from './initialState';

export default function searchPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.TOP_10_RISKS: {
      return Object.assign({}, state, {
        radarPartA: action.results
      });
    }
    case constActions.TOP_10_MALICIOUS_TRAFFIC: {
      return Object.assign({}, state, {
        radarPartB: action.results
      });
    }
    case constActions.ENTITY_WITH_HIGHEST_AV: {
      return Object.assign({}, state, {
        radarPartB: action.results
      });
    }
    case constActions.TOP_UNUSUAL_PARENTS: {
      return Object.assign({}, state, {
        radarPartC: action.results
      });
    }
    case constActions.LOW_HOST_COUNT_AND_HIGH_ACCESS_COUNT: {
      return Object.assign({}, state, {
        radarPartC: action.results
      });
    }
    case constActions.HOSTS_WITH_MALICIOUS_NETWORK: {
      return Object.assign({}, state, {
        radarPartC: action.results
      });
    }
    case constActions.HOSTS_WITH_MALICIOUS_FILE: {
      return Object.assign({}, state, {
        radarPartB: action.results
      });
    }
    case constActions.USERS_WITH_MOST_HOSTS_CONNECTIONS: {
      return Object.assign({}, state, {
        radarPartB: action.results
      });
    }
    case constActions.NEWEST_LOCAL_USERS: {
      return Object.assign({}, state, {
        radarPartC: action.results
      });
    }
    case constActions.SET_HOSTS_MAP_DATA: {
      return Object.assign({}, state, {
        hostsMapData: action.results
      });
    }
    case constActions.SHOW_HOSTS_MAP: {
      return Object.assign({}, state, {
        showHostsMap: action.result
      });
    }
    case constActions.SET_ELASTIC_GLOBAL_URL: {
      return Object.assign({}, state, {
        elasticGlobalURL: action.result
      });
    }
    // case constActions.SET_USER_ID:
    //     {
    //         return Object.assign({}, state, {
    //             userId: action.result
    //         })
    //     }
    // case constActions.SET_HOST_ID:
    //     {
    //         return Object.assign({}, state, {
    //             hostId: action.result
    //         })
    //     }
    default:
      return state;
  }
}
